<div class="content-page py-4 py-md-5 px-4 px-xxl-5">
  <div class="row">
    <ng-container *ngFor="let item of footer; let i = index">
      <div class="col-md-4" [ngClass]="{'mb-4 mb-md-0': i < footer.length - 1}">
        <div class="d-flex flex-column flex-xl-row gap-3 gap-md-4">
          <div>
            <span class="text-blue fw-bold text-footer-title">{{ item.name }}</span>
          </div>
          <div class="d-flex flex-column gap-1 gap-md-3">
            <ng-container *ngFor="let subitem of item.items; let i = index">
              <div>
                <span class="text-blue fw-light pointer text-footer-item" (click)="navigateTo(subitem.url)">{{ subitem.name }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<hr class="my-0 my-md-0">
<div class="content-page py-4 px-4 px-xxl-5">
  <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
    <div class="mb-4 mb-md-0">
      <img src="assets/svg/icon-kaizen.svg" alt="logo" width="140" routerLink="/" class="pointer">
    </div>
    <div class="d-flex gap-3 align-items-center content-icons-social justify-content-start justify-content-md-end justify-content-lg-start">
      <img src="assets/svg/icon-linkdn.svg" alt="logo" width="24">
      <img src="assets/svg/icon-instagram.svg" alt="logo" width="24">
      <img src="assets/svg/icon-twitter.svg" alt="logo" width="24">
    </div>
  </div>
</div>
<hr class="my-0 my-md-0">
<div class="content-page py-4 px-4 px-xxl-5">
  <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
    <div class="text-center text-lg-start">
      <span class="fs-8 text-blue text-footer-final">KAIZEN WEALTH PLANNING© Todos los derechos reservados</span>
    </div>
    <div>
      <a href="https://www.zeventee.com/" target="_blank" class="fs-8 text-blue text-footer-final">Diseñado y desarrollado por <span class="fw-semibold">Zeventee</span></a>
    </div>
  </div>
</div>